<!--
import { log } from 'util';
 * @Description: file content
 * @Author: yangsibo
 * @Date: 2022-05-12 10:24:14
 * @LastEditors: yangsibo
 * @LastEditTime: 2023-01-11 17:12:08
 * @FilePath: /adm.xiangli360.com/src/views/Setting/RoleManagement/components/AddRole.vue
-->
<template>
  <el-dialog
    class="dialog-bg dialog-add-role"
    title="新增角色"
    :visible.sync="dialogAddRoleVisible"
    :before-close="close"
    width="760px"
  >
    <!-- @close="closeDialogAddRole" -->
    <el-form
      :model="ruleFormAddRole"
      ref="ruleFormAddRole"
      :rules="rules"
      label-width="90px"
    >
      <el-form-item class="form-item" label="角色名称" prop="roleName">
        <el-col class="col">
          <el-input
            v-model="ruleFormAddRole.roleName"
            placeholder="请输入角色名称"
            maxlength="30"
          ></el-input>
        </el-col>
      </el-form-item>
      <el-form-item class="form-item" label="角色描述" prop="roleRemark">
        <el-col class="col">
          <el-input
            v-model="ruleFormAddRole.roleRemark"
            placeholder="请输入角色描述"
          ></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="选择权限" class="form-item-auth">
        <div class="auth left-auth">
          <el-tree
            :data="authData"
            show-checkbox
            default-expand-all
            node-key="id"
            ref="tree"
            highlight-current
            :props="defaultProps"
            @check="handleCheckChange"
          >
          </el-tree>
        </div>
        <!--  @change="handleChange" -->
        <div class="select-auth" v-show="selectedAuth.length > 0">
          <div class="select-text">
            已选权限
            <div class="popper__arrow"></div>
          </div>
          <el-collapse v-model="activeNames">
            <el-collapse-item
              :disabled="true"
              :name="item.id"
              v-for="item in selectedAuth"
              :key="item.id"
            >
              <template slot="title">
                <i
                  v-show="false"
                  class="icon-btn"
                  :class="{
                    'el-icon-caret-bottom': activeNames.includes(item.id),
                    'el-icon-caret-right': !activeNames.includes(item.id),
                  }"
                ></i>
                {{ item.menuName }}
              </template>
              <div class="explain">说明</div>
            </el-collapse-item>
          </el-collapse>
        </div>
        <!-- <div class="auth right-auth">
            <el-tree
              :data="authData"
              show-checkbox
              default-expand-all
              node-key="id"
              ref="trees"
              highlight-current
              :props="defaultProps"
            >
            </el-tree>
          </div> -->
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">取消</el-button>
      <el-button type="primary" @click="handleSaveAddRole">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "addRole",
  data() {
    return {
      ruleFormAddRole: {
        roleName: "",
        roleRemark: "",
      },
      authData: [],
      ownAuthData: [],
      checkedAuthData: [],
      defaultProps: {
        children: "children",
        label: "menuName",
      },
      selectedAuth: [],
      activeNames: [],
      rules: {
        roleName: {
          required: true,
          message: "请输入角色名称",
          trigger: "blur",
        },
      },
    };
  },
  props: {
    dialogAddRoleVisible: {
      type: Boolean,
      default: () => true,
    },
    systemType: {
      type: Number,
      default: 2,
    },
  },
  components: {},
  computed: {},
  methods: {
    /**
     * @description: 关闭弹窗
     * @Author: yangsibo
     * @Date: 2022-05-25 09:32:01
     */
    close() {
      this.$emit("close", "dialogAddRoleVisible");
    },
    /**
     * @description: 选中
     * @Author: yangsibo
     * @Date: 2022-05-25 09:48:36
     * @param {*} data
     * @param {*} checked
     * @param {*} indeterminate
     * @return {*}
     */
    handleCheckChange(data, checked, indeterminate) {
      let selectedAuth = this.$refs.tree.getCheckedNodes(false, true);
      this.selectedAuth = selectedAuth.filter((item) => {
        return item.menuType == 4;
      });
    },
    /**
     * @descripttion: 保存添加角色信息
     * @Author: juanjuanhui
     * @Date: 2022-02-23 17:05:15
     */
    handleSaveAddRole() {
      this.$refs.ruleFormAddRole.validate(async (valid) => {
        if (valid) {
          let sRefRoleMenuButtonDtos = this.$refs.tree
            .getCheckedNodes(false, true)
            .map((item) => {
              return {
                menuId: item.id, //按钮id
              };
            });
          try {
            let { status } = await this.$http.role.addSRole({
              ...this.ruleFormAddRole,
              sRefRoleMenuButtonDtos,
              systemType: this.systemType,
            });
            if (status == 1) {
              this.$message({
                type: "success",
                message: "新增角色成功",
                duration: 2000,
              });
              this.close();
              this.$emit("getRoleList");
            }
          } catch (error) {}
        } else {
          return false;
        }
      });
    },
    /**
     * @description: 获取选择权限
     * @Author: yangsibo
     * @Date: 2022-05-25 09:32:54
     * @return {*}
     */
    async selectSMenuTree() {
      try {
        let { data } = await this.$http.common.selectSMenuTree({
          systemType: this.systemType,
        });
        if (data) {
          this.authData = data;
        }
      } catch (error) {}
    },
  },
  created() {},
  mounted() {
    this.selectSMenuTree();
  },
};
</script>
<style lang="scss" scoped>
@import "./select-auth.scss";
.dialog-add-role {
  ::v-deep .el-form-item__content {
    .el-form-item__error {
      position: static !important;
      float: left !important;
      padding-top: 0 !important;
      font-size: 16px !important;
      line-height: 40px !important;
      margin-left: 10px !important;
    }
  }
  .col {
    width: 310px;
  }
  .form-item-auth {
    ::v-deep .el-form-item__content {
      display: flex;
      .auth {
        width: 310px;
        max-height: 300px;
        padding-top: 10px;
        overflow-y: auto;
        background-color: #ffffff;
        border-radius: 2px;
        border: solid 1px #e5e6eb;
        line-height: 0;
        &:first-child {
          margin-right: 20px;
        }
      }
    }
  }
}
</style>
